import { useState } from "react";
import PracticeModeSelector from "./PracticeModeSelector/PracticeModeSelector";
import styles from "./practiceReadyScreen.module.scss";

const PracticeReadyScreen = ({ onStartExamination, onGoBack, disabled = false, topicName = "SAT Practice" }) => {
    const [selectedMode, setSelectedMode] = useState(null);
    const [currentStep, setCurrentStep] = useState('mode-selection'); // 'mode-selection' or 'ready-screen'

    const handleModeSelect = (mode) => {
        setSelectedMode(mode);
    };

    const handleNext = () => {
        if (currentStep === 'mode-selection' && selectedMode) {
            setCurrentStep('ready-screen');
        } else if (currentStep === 'ready-screen' && onStartExamination) {
            onStartExamination(selectedMode);
        }
    };

    const handleBack = () => {
        if (currentStep === 'ready-screen') {
            setCurrentStep('mode-selection');
        } else {
            onGoBack();
        }
    };

    return (
        <div className={styles.readyToStartContainer}>
            <div className={styles.readyToStartContent}>
                <div className={styles.scrollableContent}>
                    {currentStep === 'mode-selection' ? (
                        <PracticeModeSelector
                            selectedMode={selectedMode}
                            onModeSelect={handleModeSelect}
                            topicName={topicName}
                        />
                    ) : (
                        <>
                            <div className={styles.readyToStartHeader}>
                                <h1 className={styles.readyTitle}>Welcome to Practice Mode for "{topicName}"</h1>
                                <p className={styles.subtitle}>Here is what you need to know:</p>
                                {disabled && (
                                    <p className={styles.disabledMessage}>
                                        ⚠️ Cannot start due to session error. Please try refreshing or going back.
                                    </p>
                                )}
                            </div>

                            <div className={styles.infoSection}>
                                <div className={styles.infoCard}>
                                    <div className={styles.infoIcon}>
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M16 4L21 9L16 14M16 18V28M11 9L6 14L11 19" stroke="#220ec9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <circle cx="16" cy="16" r="14" stroke="#220ec9" strokeWidth="2" strokeDasharray="2 4" />
                                        </svg>
                                    </div>
                                    <div className={styles.infoContent}>
                                        <h3 className={styles.infoTitle}>Practice Mode (This Mode)</h3>
                                        <p className={styles.infoText}>This is your "training gym." Its goal is to build your skills. After this session, your main dashboard score (200-800) will update (up or down) to show your new estimated ability.</p>
                                    </div>
                                </div>

                                <div className={styles.infoCard}>
                                    <div className={styles.infoIcon}>
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M16 8V16L20 20" stroke="#220ec9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <circle cx="16" cy="16" r="10" stroke="#220ec9" strokeWidth="2" />
                                            <path d="M8 4L4 8M24 4L28 8M4 24L8 28M24 28L28 24" stroke="#220ec9" strokeWidth="2" strokeLinecap="round" />
                                        </svg>
                                    </div>
                                    <div className={styles.infoContent}>
                                        <h3 className={styles.infoTitle}>Individual Response Updates</h3>
                                        <p className={styles.infoText}>Each individual response will get your personal performance metric update.</p>
                                    </div>
                                </div>

                                <div className={styles.infoCard}>
                                    <div className={styles.infoIcon}>
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M16 10V22M10 16H22" stroke="#220ec9" strokeWidth="2" strokeLinecap="round" />
                                            <rect x="6" y="6" width="20" height="20" rx="3" stroke="#220ec9" strokeWidth="2" />
                                        </svg>
                                    </div>
                                    <div className={styles.infoContent}>
                                        <h3 className={styles.infoTitle}>Performance-Based Queue</h3>
                                        <p className={styles.infoText}>Your personal performance metric will determine which questions appear next in the queue. To reset this for a fresh start, check <button type="button" className={styles.guideLink} onClick={() => { alert('Guide link - to be implemented'); }}>this guide here</button>.</p>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>

                <div className={styles.buttonContainer}>
                    <button
                        className={styles.goBackButton}
                        onClick={handleBack}
                    >
                        <span className={styles.goBackButtonText}>← Go Back</span>
                    </button>

                    <button
                        className={`${styles.startButton} ${((currentStep === 'mode-selection' && !selectedMode) || disabled) ? styles.disabledButton : ''}`}
                        onClick={((currentStep === 'mode-selection' && !selectedMode) || disabled) ? undefined : handleNext}
                        disabled={(currentStep === 'mode-selection' && !selectedMode) || disabled}
                    >
                        <span className={styles.startButtonText}>
                            {disabled ? 'Unavailable' : currentStep === 'mode-selection' ? 'Next' : 'Start Practice'}
                        </span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PracticeReadyScreen;